import { getAuth } from 'firebase/auth';

/**
 * Resolves the value used as `registrationMethod` in the registration GTM
 * dataLayer event.
 **/
const mapFirebaseProviderId = (
  providerId: string | undefined | null
): string | null => {
  if (!providerId) return null;
  switch (providerId) {
    case 'password':
      return 'email';
    case 'phone':
      return 'phone';
    case 'google.com':
      return 'google';
    case 'apple.com':
      return 'apple';
    default:
      return providerId;
  }
};

const getRegistrationMethod = (
  lastAuthProvider?: string | null
): string | null => {
  if (lastAuthProvider) return lastAuthProvider;

  try {
    const currentUser = getAuth().currentUser;
    const providerId = currentUser?.providerData?.[0]?.providerId;
    return mapFirebaseProviderId(providerId);
  } catch {
    return null;
  }
};

export default getRegistrationMethod;
